import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { connect } from 'react-redux'
import { useHistory } from "react-router-dom";
import { setLoading, setSnackInfo } from '../redux/actions/appAction';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { ROLENAME } from '../utils';
import moment from 'moment';
import Dialog from '@material-ui/core/Dialog';
import { Modal } from 'antd';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import HttpService from '../services/httpService';
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Box, Typography, IconButton, CircularProgress, Tooltip } from '@material-ui/core';
// Material icons throughout instead of the Ant Design outlined set. The two
// families have different stroke weights and corner radii, so mixing them with
// the MUI controls already on this page made it look assembled from spare
// parts - the same swap made across the call-recording and referral pages.
import CardGiftcardOutlinedIcon from '@material-ui/icons/CardGiftcardOutlined';
import StorefrontOutlinedIcon from '@material-ui/icons/StorefrontOutlined';
import TuneIcon from '@material-ui/icons/Tune';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import InboxOutlinedIcon from '@material-ui/icons/InboxOutlined';
import CloseIcon from '@material-ui/icons/Close';
import RefreshIcon from '@material-ui/icons/Refresh';

// Brand orange - sampled from the actual Decorpot logo, same palette used
// across the rest of the app's recently-redesigned pages.
const ORANGE = "#F47E44";
const ORANGE_DARK = "#c1531f";
const ORANGE_LIGHT = "#fff1ea";
const HEADER_GRADIENT = `linear-gradient(135deg, ${ORANGE_DARK} 0%, ${ORANGE} 60%, #ff9c66 100%)`;
const GREEN = "#1e8449";
const GREEN_GRADIENT = `linear-gradient(135deg, #146c43, ${GREEN})`;
const RED = "#c0392b";
const RED_LIGHT = "#fdecea";
// Matches the "Silka bold" heading treatment used on the lead details
// (manageProjectLog) page, so headings here read consistently with the rest
// of the app. Body text already inherits "Silka regular" globally via App.css.
const HEADING_FONT = "'Silka bold', 'Silka semiBold', sans-serif !important";

// Two-letter monogram for the requester / assignee cells.
const initialsOf = (name = "") =>
    String(name).trim().split(/\s+/).slice(0, 2).map((w) => w[0]).join("").toUpperCase() || "?";

const useStyles = makeStyles(() => ({
    page: { padding: 20, background: "#f6f7fb", minHeight: "100vh" },
    headerCard: {
        marginBottom: 20,
        borderRadius: 16,
        overflow: "hidden",
        boxShadow: "0 10px 28px rgba(196,83,31,0.2)",
        background: HEADER_GRADIENT,
        padding: "22px 26px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 16,
    },
    headerLeft: { display: "flex", alignItems: "center", gap: 16 },
    headerActions: { display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" },
    "@keyframes spin": { from: { transform: "rotate(0deg)" }, to: { transform: "rotate(360deg)" } },
    "@keyframes pulseDot": {
        "0%, 100%": { opacity: 1, transform: "scale(1)" },
        "50%": { opacity: 0.45, transform: "scale(0.82)" },
    },
    // Solid white with a dark ring: the ring defines the EDGE, since white on
    // the bright #ff9c66 end of the gradient is only about 2:1. The word
    // "Refresh" is what makes the control findable at all.
    refreshButton: {
        display: "inline-flex", alignItems: "center", gap: 7,
        padding: "8px 16px", borderRadius: 999, border: "none",
        background: "#fff", color: ORANGE_DARK,
        fontSize: 12.5, fontWeight: 800, letterSpacing: 0.2, fontFamily: "inherit",
        cursor: "pointer",
        boxShadow: "0 0 0 1px rgba(0,0,0,0.14), 0 3px 10px rgba(0,0,0,0.24)",
        transition: "background .18s ease, transform .18s ease, box-shadow .18s ease",
        "&:hover:not(:disabled)": {
            background: ORANGE_LIGHT, transform: "translateY(-1px)",
            boxShadow: "0 0 0 1px rgba(0,0,0,0.18), 0 6px 16px rgba(0,0,0,0.3)",
        },
        "&:active:not(:disabled)": { transform: "translateY(0)" },
        "&:disabled": { cursor: "wait", opacity: 0.85 },
    },
    refreshSpinning: { animation: "$spin 0.9s linear infinite" },
    lastUpdatedText: {
        display: "inline-flex", alignItems: "center", gap: 6,
        fontSize: 11, fontWeight: 600, color: "#fff",
        background: "rgba(0,0,0,0.42)", padding: "3px 10px", borderRadius: 999,
        whiteSpace: "nowrap",
    },
    liveDot: {
        width: 6, height: 6, borderRadius: "50%", flexShrink: 0,
        background: "#FFD2B5", animation: "$pulseDot 2s ease-in-out infinite",
    },
    headerIconWrap: {
        width: 52,
        height: 52,
        borderRadius: "50%",
        background: "rgba(255,255,255,0.22)",
        border: "2px solid rgba(255,255,255,0.35)",
        boxShadow: "0 4px 14px rgba(0,0,0,0.15)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
    },
    statChip: {
        background: "rgba(255,255,255,0.2)",
        color: "#fff",
        borderRadius: 20,
        padding: "7px 16px",
        fontWeight: 700,
        fontSize: 13,
        display: "flex",
        alignItems: "center",
        gap: 6,
        whiteSpace: "nowrap",
    },
    filterCard: {
        borderRadius: 16,
        boxShadow: "0 6px 20px rgba(17,24,39,0.06)",
        padding: "18px 22px",
        marginBottom: 20,
        background: "#fff",
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 16,
    },
    sectionLabel: {
        display: "flex",
        alignItems: "center",
        gap: 6,
        color: "#6b7280",
        fontSize: 12.5,
        fontWeight: 700,
        textTransform: "uppercase",
        letterSpacing: 0.4,
        marginRight: 4,
    },
    field: {
        width: 280,
        flex: "0 0 auto",
        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: ORANGE },
        '& .MuiInputLabel-root.Mui-focused': { color: ORANGE_DARK },
    },
    tableCard: { borderRadius: 16, overflow: "hidden", boxShadow: "0 6px 20px rgba(17,24,39,0.06)", background: "#fff" },
    tableWrap: { maxHeight: 850, overflow: "auto" },
    tableHeadCell: {
        // Solid, not a gradient: across a wide table the gradient's light end
        // left the right-hand headers washed out (white on #ff9c66 is only
        // ~2:1), and a flat band keeps every label at 4.64:1.
        // `!important` is still needed: MUI's stickyHeader rule paints its
        // own background on th.
        background: `${ORANGE_DARK} !important`,
        color: "#fff",
        fontWeight: 700,
        fontSize: 11.5,
        letterSpacing: "0.05em",
        textTransform: "uppercase",
        textAlign: "center",
        whiteSpace: "nowrap",
        borderBottom: "none",
    },
    tableRow: {
        "&:nth-of-type(odd)": { backgroundColor: "#FBFBFA" },
        "&:hover": { backgroundColor: ORANGE_LIGHT, boxShadow: `inset 3px 0 0 ${ORANGE}` },
        transition: "background-color .12s ease, box-shadow .12s ease",
    },
    tableCellCss: {
        textAlign: 'center',
        fontSize: 13.5,
        color: "#2b3648",
        borderBottom: "1px solid #f1f2f5",
    },
    rankCell: { color: "#9aa1ac", fontWeight: 800, fontVariantNumeric: "tabular-nums" },
    // Identity, not decoration: the same requester and assignee recur down the
    // list, and an initial makes a repeated name findable while scanning.
    personCell: { display: "flex", alignItems: "center", justifyContent: "center", gap: 8 },
    personAvatar: {
        width: 26, height: 26, borderRadius: "50%", flexShrink: 0,
        display: "flex", alignItems: "center", justifyContent: "center",
        background: ORANGE_LIGHT, color: ORANGE_DARK,
        fontSize: 11, fontWeight: 800,
    },
    // A lead number is an identifier people copy and compare, so it gets the
    // same pill treatment used across the other redesigned tables.
    leadPill: {
        display: "inline-flex", alignItems: "center", gap: 4,
        padding: "3px 10px", borderRadius: 7,
        background: ORANGE_LIGHT, color: ORANGE_DARK,
        fontWeight: 700, fontSize: 12.5,
        fontVariantNumeric: "tabular-nums", whiteSpace: "nowrap",
    },
    // Budgets are compared down the column, so tabular figures - proportional
    // digits meant the amounts never lined up.
    amountCell: {
        fontWeight: 800, color: "#2b3648",
        fontVariantNumeric: "tabular-nums", whiteSpace: "nowrap",
    },
    dateStack: { lineHeight: 1.35 },
    dateMain: { fontSize: 12.5, fontWeight: 700, color: "#2b3648", whiteSpace: "nowrap" },
    dateSub: { fontSize: 11, color: "#9aa1ac", whiteSpace: "nowrap" },
    viewBtn: {
        color: "#fff",
        background: `linear-gradient(135deg, ${ORANGE_DARK}, ${ORANGE})`,
        textTransform: "none",
        fontWeight: 600,
        borderRadius: 10,
        boxShadow: "none",
        "&:hover": { background: `linear-gradient(135deg, #a8441a, ${ORANGE_DARK})`, boxShadow: "0 6px 16px rgba(244,126,68,0.35)" },
    },
    approveBtn: {
        color: "#fff",
        background: GREEN_GRADIENT,
        textTransform: "none",
        fontWeight: 600,
        borderRadius: 10,
        boxShadow: "none",
        "&:hover": { background: "linear-gradient(135deg, #0f5132, #146c43)", boxShadow: "0 6px 16px rgba(30,132,73,0.3)" },
        "&:disabled": { background: "rgba(0,0,0,0.12)", color: "rgba(0,0,0,0.38)" },
    },
    rejectBtn: {
        color: RED,
        border: `1.5px solid ${RED}`,
        background: "#fff",
        textTransform: "none",
        fontWeight: 600,
        borderRadius: 10,
        "&:hover": { background: RED_LIGHT },
        "&:disabled": { border: "1.5px solid rgba(0,0,0,0.12)", color: "rgba(0,0,0,0.38)" },
    },
    clearBtn: {
        color: "#6b7280",
        border: "1.5px solid #d8dee8",
        background: "#fff",
        textTransform: "none",
        fontWeight: 600,
        borderRadius: 10,
        "&:hover": { background: "#f5f6f8", borderColor: "#c3cad6" },
    },
    statusChip: {
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        borderRadius: 20,
        padding: "4px 12px",
        fontSize: 12,
        fontWeight: 700,
    },
    // What is left to act on, before you read a single row. The modal is a
    // work queue, so "3 still to decide" is the fact that decides whether you
    // need to be here at all.
    itemsSummary: {
        display: "flex", flexWrap: "wrap", gap: 8, alignItems: "center",
        padding: "10px 14px", marginBottom: 10,
        background: "#FBFBFA", borderRadius: 12, border: "1px solid #eef0f3",
    },
    summaryPill: {
        display: "inline-flex", alignItems: "center", gap: 6,
        padding: "4px 12px", borderRadius: 999,
        fontSize: 12, fontWeight: 700, whiteSpace: "nowrap",
    },
    spaceTag: {
        display: "inline-flex", alignItems: "center", gap: 5,
        padding: "3px 10px", borderRadius: 7,
        background: "#eef2f8", color: "#2a4d7a",
        fontSize: 12, fontWeight: 700, whiteSpace: "nowrap",
    },
    // Bounded so a long item list scrolls inside the modal instead of pushing
    // the approve/reject buttons off the bottom of the screen.
    itemsTableWrap: { maxHeight: "52vh", overflow: "auto" },
    emptyState: { padding: "60px 20px", textAlign: "center", color: "#9aa1ac" },
    emptyIconWrap: {
        width: 80,
        height: 80,
        borderRadius: "50%",
        background: ORANGE_LIGHT,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "0 auto 14px",
    },
    modalTitle: {
        display: "flex",
        alignItems: "center",
        gap: 10,
        fontFamily: HEADING_FONT,
        fontSize: 17,
        color: ORANGE_DARK,
    },
    dialogHeader: {
        background: HEADER_GRADIENT,
        color: "#fff",
        padding: "18px 24px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 10,
    },
    dialogHeaderTitle: { display: "flex", alignItems: "center", gap: 10 },
    dialogCloseBtn: {
        color: "rgba(255,255,255,0.9)",
        "&:hover": { backgroundColor: "rgba(255,255,255,0.15)" },
    },
}));


const StyledTableCell = withStyles(() => ({
    head: {
        // Solid, not a gradient: across a wide table the gradient's light end
        // left the right-hand headers washed out (white on #ff9c66 is only
        // ~2:1), and a flat band keeps every label at 4.64:1.
        // `!important` is still needed: MUI's stickyHeader rule paints its
        // own background on th.
        background: `${ORANGE_DARK} !important`,
        color: "#fff",
        fontWeight: 700,
        fontSize: 11.5,
        letterSpacing: "0.05em",
        textTransform: "uppercase",
        textAlign: 'center',
        borderBottom: "none",
    },
    body: {
        fontSize: 13.5,
        textAlign: 'center',
        color: "#2b3648",
        borderBottom: "1px solid #f1f2f5",
    },
}))(TableCell);

const StyledTableRow = withStyles(() => ({
    root: {
        '&:nth-of-type(odd)': { backgroundColor: "#FBFBFA" },
        '&:hover': { backgroundColor: ORANGE_LIGHT, boxShadow: `inset 3px 0 0 ${ORANGE}` },
        transition: "background-color .12s ease",
    },
}))(TableRow);

function ComplimentaryApprovalView(props) {
    const classes = useStyles()
    const { userDetails } = useSelector(state => state.user);
    const history = useHistory();
    const [complimentaryItemsApprovalLeads, setComplimentaryItemsApprovalLeads] = useState([]);
    const [allComplimentaryItems, setAllComplimentaryItems] = useState([]);
    const [data, setData] = useState({
        "assignTo": "",
        "complimentaryItemRequestedBy": ""
    });
    const [openItemsModal, setOpenItemsModal] = useState(false);
    const [projectId, setProjectId] = useState("")
    // When the rows on screen were last pulled, so the header can say how stale
    // they are. Only set on a successful fetch - a failed refresh must not make
    // old rows look fresh.
    const [lastUpdated, setLastUpdated] = useState(null);
    // "Updated 4 minutes ago" is only true at the instant it renders, so a slow
    // tick re-renders it. 30s is plenty - moment rounds to the minute anyway.
    const [nowTick, setNowTick] = useState(Date.now());
    useEffect(() => {
        const id = setInterval(() => setNowTick(Date.now()), 30000);
        return () => clearInterval(id);
    }, []);
    // The centres the visible rows were fetched with, so Refresh repeats the
    // same query instead of silently dropping the filter.
    const [appliedExpCenter, setAppliedExpCenter] = useState(undefined);
    const [openProjectLogsModal, setOpenProjectLogsModal] = useState(false)
    const [projectLogsData, setProjectLogsData] = useState([]);
    const [remarkDialog, setRemarksDialog] = useState(false)
    const [rejectItemInfo, setRejectItemInfo] = useState({
        spaceName: '',
        proIndex: null,
    });

    const [selectedExperienceCenter, setSelectedExperienceCenter] = useState([]);
    const [commonExpCenter, setExpCenter] = useState([]);
    // Local, in-table loader plus a per-action submitting flag - button
    // clicks give immediate, visible feedback instead of relying solely on
    // the app-wide Backdrop.
    const [dataLoading, setDataLoading] = useState(false);
    const [submittingItem, setSubmittingItem] = useState(false);

    // Function to handle the exp center select
    const handleMultipleExpData = (event, newValue) => {
        setSelectedExperienceCenter(newValue)
        getAllApprovedLeads(newValue);
    }

    // Function to get exp center to which current use is tagged
    const expCenters = async () => {
        props.setLoading(true);
        try {
            let response = await HttpService.getExpericenCenters();
            const matchedUsers = response.data.filter(user => {
                return userDetails.experienceCenterId.includes(user._id);
            });
            setExpCenter(matchedUsers)
        } catch (error) {
            console.error("Error fetching experience centers:", error);
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }

    useEffect(() => {
        getAllApprovedLeads();
        expCenters();
        // eslint-disable-next-line
    }, [])

    const getAllApprovedLeads = async (selectedExpCenter) => {
        setDataLoading(true)
        let expCenterData = selectedExpCenter?.map((el) => el._id)
        try {
            let expCenterId = expCenterData?.length > 0 ? expCenterData : userDetails.selectedExpCenter
            const response = await HttpService.getComplimentaryItemsApprovalLeads(expCenterId);
            if (response.data == "No leads found.") {
                setComplimentaryItemsApprovalLeads([])
            } else {
                setComplimentaryItemsApprovalLeads(response.data);
            }
            // Inside the try, after the assignments: a fetch that threw leaves
            // the previous timestamp alone rather than vouching for stale rows.
            setLastUpdated(new Date());
            setAppliedExpCenter(selectedExpCenter);
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something went wrong", "error")
        }
        setDataLoading(false)
    }

    const showLogs = (data) => {
        setOpenProjectLogsModal(true);
        setProjectLogsData(data);
    }

    // Counts for the modal's summary strip. Derived from the same nested shape
    // the table walks (lead -> complimentaryItems -> productNames), so the
    // numbers cannot drift from the rows underneath them. `itemApproved`
    // undefined means nobody has decided yet - that is the pending state the
    // table itself keys on.
    const itemsSummary = React.useMemo(() => {
        const out = { total: 0, pending: 0, approved: 0, rejected: 0 };
        if (!projectId) return out;
        const lead = complimentaryItemsApprovalLeads.find((l) => l._id === projectId);
        for (const item of lead?.complimentaryItems || []) {
            for (const pro of item?.productNames || []) {
                out.total += 1;
                if (pro.itemApproved === undefined) out.pending += 1;
                else if (pro.chApproved) out.approved += 1;
                else out.rejected += 1;
            }
        }
        return out;
    }, [projectId, complimentaryItemsApprovalLeads]);

    const showItems = (data) => {
        let obj = {
            assignTo: data?.assignTo?._id,
            complimentaryItemRequestedBy: data?.complimentaryItemRequestedBy ? data?.complimentaryItemRequestedBy?._id : ''
        }
        setData(obj);
        setOpenItemsModal(true)
        setProjectId(data?._id)
    }

    const handleRejectedRemarks = (event) => {
        // setRemarksDialog(true)
        data.rejectedRemarks = event.target.value
    }

    const handleRejectButtonClick = (spaceName, index) => {
        setRemarksDialog(true);
        setRejectItemInfo({ spaceName, proIndex: index });
    };


    const approveComplimentaryItems = async (spaceName, proIndex, status) => {
        setSubmittingItem(true)

        let existingComplimentaryItems = []
        let rejectedItems = []
        let approvedItems = []


        projectId && complimentaryItemsApprovalLeads.forEach((lead) => {
            // Check if the lead's _id matches the projectId
            if (lead._id === projectId) {
                // Iterate through complimentaryItems within the lead
                lead.complimentaryItems.forEach((item) => {
                    if (item.productNames && item.productNames.length > 0) {
                        existingComplimentaryItems.push({
                            spaceName: item.spaceName,
                            productNames: item.productNames.map((product) => ({
                                name: product.name,
                                area: product.area,
                                chApproved: product.chApproved
                            }))
                        });
                    }
                    // Create an array to hold the updated productNames
                    const updatedProductNames = [];

                    // Iterate through productNames array within the item
                    item.productNames.forEach((product, productIndex) => {
                        // Update chApproval based on the status
                        if (status && proIndex === productIndex && spaceName === item.spaceName) {
                            // Update the entire productNames array
                            item.productNames[productIndex] = {
                                name: product.name,
                                area: product.area,
                                chApproved: true,
                                itemApproved: true
                            };

                            // Push the updated product to the array
                            updatedProductNames[productIndex] = [{
                                name: item.productNames[productIndex].name,
                                area: item.productNames[productIndex].area,
                                chApproved: item.productNames[productIndex].chApproved,
                                itemApproved: item.productNames[productIndex].itemApproved
                            }]

                        } else if (status === false && proIndex === productIndex && spaceName === item.spaceName) {
                            item.productNames[productIndex] = {
                                name: product.name,
                                area: product.area,
                                chApproved: false,
                                itemApproved: false
                            };

                            // Push the updated product to the array
                            updatedProductNames.push({
                                name: item.productNames[productIndex].name,
                                area: item.productNames[productIndex].area,
                                chApproved: item.productNames[productIndex].chApproved,
                                itemApproved: item.productNames[productIndex].itemApproved
                            });
                        }
                        // Find the existingComplimentaryItems element with the matching spaceName
                        const existingItemIndex = existingComplimentaryItems.findIndex(existingItem => existingItem.spaceName === item.spaceName);

                        if (existingItemIndex !== -1) {
                            // Update only the specific productIndex in the productNames array
                            existingComplimentaryItems[existingItemIndex].productNames[productIndex] = {
                                name: item.productNames[productIndex].name,
                                area: item.productNames[productIndex].area,
                                chApproved: item.productNames[productIndex].chApproved,
                                itemApproved: item.productNames[productIndex].itemApproved
                            };
                        }
                    });
                });
            }
        });


        // approvedComplimentaryItems = [...existingComplimentaryItems, ...approvedComplimentaryItems]
        existingComplimentaryItems.forEach((item) => {
            let hasRejectedProduct = false; // Flag to track if any product has 'itemApproved' as false
            let allProductsApproved = true; // Flag to track if all products are approved
            item.productNames.forEach((product) => {
                if (product.itemApproved === false) {
                    // If any product has 'itemApproved' as false, set the flag to true
                    hasRejectedProduct = true;
                    rejectedItems.push({
                        spaceName: item.spaceName,
                        name: product.name,
                        area: product.area,
                        chApproved: product.chApproved,
                        itemApproved: product.itemApproved
                    });
                    // data.complimentaryItemApproval = false
                    data.complimentaryItemStatus = 'Rejected';
                }
                else if (product.itemApproved === true) {
                    approvedItems.push({
                        spaceName: item.spaceName,
                        name: product.name,
                        area: product.area,
                        chApproved: product.chApproved,
                        itemApproved: product.itemApproved
                    });
                    // data.complimentaryItemApproval = true
                    data.complimentaryItemStatus = 'Approved';
                }

                if (product.itemApproved == undefined) {
                    // If any product has 'itemApproved' as undefined, set the flag to false
                    allProductsApproved = false;
                }
            });

            // Set the status based on conditions
            if (allProductsApproved) {
                if (hasRejectedProduct) {
                    data.complimentaryItemApproval = false;
                } else {
                    data.complimentaryItemApproval = true;
                }
            }
        });


        data.rejectedItems = rejectedItems
        data.approvedItems = approvedItems
        data.complimentaryItems = existingComplimentaryItems
        setAllComplimentaryItems(existingComplimentaryItems)
        try {
            const updateComplimentaryItems = await HttpService.approveComplimentaryItems(projectId, data)
        } catch (error) {
            console.log(error, "error")
        }
        setSubmittingItem(false)
    }

    const canViewPage = userDetails?.roles && userDetails.roles.some(role => [
        ROLENAME.DGM_Sales, ROLENAME.DGM_Design, ROLENAME.AGM_Design, ROLENAME.SalesHead,
        ROLENAME.AGM_Sales, ROLENAME.CenterHead, ROLENAME.Admin, ROLENAME.NaraciTechManager,
        ROLENAME.NaraciTechUser
    ].includes(role.name));

    return (
        <div className={classes.page}>

            {canViewPage && (
                <>
                    {/* HEADER */}
                    <Box className={classes.headerCard}>
                        <Box className={classes.headerLeft}>
                            <Box className={classes.headerIconWrap}>
                                <CardGiftcardOutlinedIcon style={{ color: "#fff", fontSize: 26 }} />
                            </Box>
                            <Box>
                                <Typography style={{ color: "#fff", fontFamily: HEADING_FONT, fontSize: 21, margin: 0 }}>
                                    Complimentary Approval
                                </Typography>
                                <Typography style={{ color: "rgba(255,255,255,0.88)", fontSize: 13.5, marginTop: 4 }}>
                                    Review and action complimentary items requested on projects
                                </Typography>
                            </Box>
                        </Box>

                        <Box className={classes.headerActions}>
                            <Box className={classes.statChip}>
                                <CardGiftcardOutlinedIcon style={{ fontSize: 15 }} />
                                {complimentaryItemsApprovalLeads.length} Pending Request{complimentaryItemsApprovalLeads.length === 1 ? "" : "s"}
                            </Box>

                            <Tooltip
                                title={
                                    lastUpdated
                                        ? `Last pulled at ${moment(lastUpdated).format("DD MMM YYYY, hh:mm:ss A")} — click to fetch the latest requests`
                                        : "Fetch the latest requests"
                                }
                            >
                                {/* A labelled button rather than an IconButton: the
                                    word "Refresh" is what makes the control findable,
                                    and a tooltip alone only helps people who already
                                    hovered. The span is required because a disabled
                                    button fires no mouse events, so the tooltip would
                                    die exactly mid-refresh. */}
                                <span style={{ display: "inline-flex" }}>
                                    <button
                                        type="button"
                                        className={classes.refreshButton}
                                        onClick={() => getAllApprovedLeads(appliedExpCenter)}
                                        disabled={dataLoading}
                                    >
                                        <RefreshIcon
                                            className={dataLoading ? classes.refreshSpinning : undefined}
                                            style={{ fontSize: 17 }}
                                        />
                                        {dataLoading ? "Refreshing…" : "Refresh"}
                                    </button>
                                </span>
                            </Tooltip>

                            {lastUpdated && (
                                <Box className={classes.lastUpdatedText}>
                                    <span className={classes.liveDot} />
                                    {/* Relative beats a clock time: it answers "is
                                        this stale?" without the reader doing the
                                        arithmetic. */}
                                    {dataLoading ? "Fetching latest…" : `Updated ${moment(lastUpdated).from(nowTick)}`}
                                </Box>
                            )}
                        </Box>
                    </Box>

                    {/* FILTER */}
                    <Box className={classes.filterCard}>
                        <Typography className={classes.sectionLabel}>
                            <TuneIcon style={{ fontSize: 15 }} />
                            Filters
                        </Typography>

                        <FormControl className={classes.field}>
                            <Autocomplete
                                multiple
                                value={selectedExperienceCenter}
                                onChange={handleMultipleExpData}
                                options={commonExpCenter}
                                getOptionLabel={(option) => option.name}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Select Exp-Center"
                                        variant="outlined"
                                        size="small"
                                        InputProps={{
                                            ...params.InputProps,
                                            startAdornment: (
                                                <>
                                                    <StorefrontOutlinedIcon style={{ fontSize: 16, color: "#9aa1ac", marginRight: 4 }} />
                                                    {params.InputProps.startAdornment}
                                                </>
                                            ),
                                        }}
                                    />
                                )}
                            />
                        </FormControl>
                    </Box>

                    {/* TABLE */}
                    <Box className={classes.tableCard}>
                        {dataLoading ? (
                            <Box style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "60px 0" }}>
                                <CircularProgress style={{ color: ORANGE }} />
                                <Typography style={{ color: "#9aa1ac", marginTop: 10 }}>Loading requests...</Typography>
                            </Box>
                        ) : complimentaryItemsApprovalLeads.length === 0 ? (
                            <Box className={classes.emptyState}>
                                <Box className={classes.emptyIconWrap}>
                                    <InboxOutlinedIcon style={{ fontSize: 36, color: ORANGE_DARK }} />
                                </Box>
                                <Typography style={{ fontWeight: 600, color: "#7d8794" }}>
                                    No Records Found
                                </Typography>
                                <Typography variant="body2" style={{ color: "#a4abb5", marginTop: 4 }}>
                                    There are currently no projects requiring complimentary item approval.
                                </Typography>
                            </Box>
                        ) : (
                            <TableContainer className={classes.tableWrap}>
                                <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className={classes.tableHeadCell}>Sl. No</TableCell>
                                            <TableCell className={classes.tableHeadCell}>Customer Name</TableCell>
                                            <TableCell className={classes.tableHeadCell}>Lead No.</TableCell>
                                            <TableCell className={classes.tableHeadCell}>CreatedAt</TableCell>
                                            <TableCell className={classes.tableHeadCell}>Budget</TableCell>
                                            <TableCell className={classes.tableHeadCell}>Requested By</TableCell>
                                            <TableCell className={classes.tableHeadCell}>Assigned To / Action</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {complimentaryItemsApprovalLeads
                                            .sort((a, b) => b.createdAt.split('-').reverse().join().localeCompare(a.createdAt.split('-').reverse().join()))
                                            .map((row, i) => (
                                                <TableRow key={i + 1} className={classes.tableRow}>
                                                    <TableCell className={`${classes.tableCellCss} ${classes.rankCell}`}>{i + 1}</TableCell>
                                                    <TableCell className={classes.tableCellCss}>
                                                        <strong style={{ fontWeight: 600 }}>{row?.customerId?.name || 'NA'}</strong>
                                                    </TableCell>
                                                    <TableCell className={classes.tableCellCss}>
                                                        {row?.lead_no
                                                            ? <span className={classes.leadPill}>{row.lead_no}</span>
                                                            : <span style={{ color: "#9aa1ac" }}>NA</span>}
                                                    </TableCell>
                                                    <TableCell className={classes.tableCellCss}>
                                                        {row?.createdAt ? (
                                                            <div className={classes.dateStack}>
                                                                <div className={classes.dateMain}>{moment(row.createdAt).format('DD MMM YYYY')}</div>
                                                                <div className={classes.dateSub}>{moment(row.createdAt).fromNow()}</div>
                                                            </div>
                                                        ) : <span style={{ color: "#9aa1ac" }}>NA</span>}
                                                    </TableCell>
                                                    <TableCell className={`${classes.tableCellCss} ${classes.amountCell}`}>
                                                        {row?.grandTotal != null
                                                            ? `₹${Number(row.grandTotal).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`
                                                            : <span style={{ color: "#9aa1ac", fontWeight: 400 }}>NA</span>}
                                                    </TableCell>
                                                    <TableCell className={classes.tableCellCss}>
                                                        {row?.complimentaryItemRequestedBy?.name ? (
                                                            <div className={classes.personCell}>
                                                                <span className={classes.personAvatar}>{initialsOf(row.complimentaryItemRequestedBy.name)}</span>
                                                                <span>{row.complimentaryItemRequestedBy.name}</span>
                                                            </div>
                                                        ) : <span style={{ color: "#9aa1ac" }}>NA</span>}
                                                    </TableCell>
                                                    <TableCell className={classes.tableCellCss}>
                                                        <Box style={{ display: 'flex', alignItems: "center", justifyContent: 'space-between', gap: 10 }}>
                                                            {row?.assignTo?.name ? (
                                                                <div className={classes.personCell}>
                                                                    <span className={classes.personAvatar}>{initialsOf(row.assignTo.name)}</span>
                                                                    <span>{row.assignTo.name}</span>
                                                                </div>
                                                            ) : <span style={{ color: "#9aa1ac" }}>NA</span>}
                                                            <Tooltip title={`See the complimentary items requested for ${row?.customerId?.name || 'this lead'}`}>
                                                                <Button
                                                                    variant='contained'
                                                                    size="small"
                                                                    className={classes.viewBtn}
                                                                    onClick={() => showItems(row)}
                                                                    startIcon={<VisibilityOutlinedIcon style={{ fontSize: 16 }} />}
                                                                >
                                                                    View
                                                                </Button>
                                                            </Tooltip>
                                                        </Box>
                                                    </TableCell>
                                                </TableRow>
                                            ))
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        )}
                    </Box>
                </>
            )}


            <Modal
                title={
                    <span className={classes.modalTitle}>
                        <CardGiftcardOutlinedIcon />
                        Complimentary Items
                    </span>
                }
                centered
                visible={openItemsModal}
                onCancel={() => {
                    setOpenItemsModal(false);
                    getAllApprovedLeads()
                }}
                width={1000}
                maskClosable={false}
                footer={null}
            >
                <DialogContent style={{ padding: "8px 0 0" }}>
                    {itemsSummary.total > 0 && (
                        <Box className={classes.itemsSummary}>
                            <span className={classes.summaryPill} style={{ background: "#eef2f8", color: "#2a4d7a" }}>
                                {itemsSummary.total} item{itemsSummary.total === 1 ? "" : "s"}
                            </span>
                            <span
                                className={classes.summaryPill}
                                style={{ background: itemsSummary.pending ? "#FFF4E5" : "#f1f2f5", color: itemsSummary.pending ? "#8a4b00" : "#9aa1ac" }}
                            >
                                {itemsSummary.pending} awaiting your decision
                            </span>
                            <span className={classes.summaryPill} style={{ background: "#eafaf1", color: GREEN }}>
                                <CheckCircleOutlineIcon style={{ fontSize: 14 }} />
                                {itemsSummary.approved} approved
                            </span>
                            <span className={classes.summaryPill} style={{ background: RED_LIGHT, color: RED }}>
                                <HighlightOffIcon style={{ fontSize: 14 }} />
                                {itemsSummary.rejected} rejected
                            </span>
                            {itemsSummary.pending === 0 && (
                                <span style={{ marginLeft: "auto", fontSize: 12, fontWeight: 700, color: GREEN }}>
                                    Nothing left to decide here
                                </span>
                            )}
                        </Box>
                    )}
                    <TableContainer className={classes.itemsTableWrap}>
                        <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell>Sl No.</StyledTableCell>
                                    <StyledTableCell>Space Name</StyledTableCell>
                                    <StyledTableCell>Complimentary Items</StyledTableCell>
                                    <StyledTableCell>Area(Sq/Ft)/Qty</StyledTableCell>
                                    <StyledTableCell>Actions/Status</StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                                {projectId && (
                                    complimentaryItemsApprovalLeads.map((lead, leadIndex) => (
                                        lead._id === projectId && (
                                            lead.complimentaryItems.map((item, itemIndex) => (
                                                item.productNames.map((pro, proIndex) => (
                                                    <StyledTableRow key={`${proIndex}`}>
                                                        <StyledTableCell>{proIndex + 1}</StyledTableCell>
                                                        <StyledTableCell>
                                                            <span className={classes.spaceTag}>{item.spaceName}</span>
                                                        </StyledTableCell>
                                                        <StyledTableCell>
                                                            <strong style={{ fontWeight: 600 }}>{pro.name}</strong>
                                                        </StyledTableCell>
                                                        <StyledTableCell style={{ fontVariantNumeric: "tabular-nums", fontWeight: 600 }}>
                                                            {pro.area}
                                                        </StyledTableCell>
                                                        <StyledTableCell>
                                                            {pro.itemApproved === undefined ? (
                                                                <Box style={{ display: 'flex', gap: 8, justifyContent: "center" }}>
                                                                    <Button
                                                                        onClick={() => handleRejectButtonClick(item.spaceName, proIndex)}
                                                                        variant="outlined"
                                                                        size="small"
                                                                        disabled={submittingItem}
                                                                        className={classes.rejectBtn}
                                                                        startIcon={<HighlightOffIcon />}
                                                                    >
                                                                        Reject
                                                                    </Button>
                                                                    <Button
                                                                        onClick={() => approveComplimentaryItems(item.spaceName, proIndex, true)}
                                                                        variant="contained"
                                                                        size="small"
                                                                        disabled={submittingItem}
                                                                        className={classes.approveBtn}
                                                                        startIcon={submittingItem ? <CircularProgress size={14} style={{ color: "#fff" }} /> : <CheckCircleOutlineIcon />}
                                                                    >
                                                                        Approve
                                                                    </Button>
                                                                </Box>
                                                            ) : (
                                                                <span
                                                                    className={classes.statusChip}
                                                                    style={{
                                                                        background: pro.chApproved ? "#eafaf1" : RED_LIGHT,
                                                                        color: pro.chApproved ? GREEN : RED,
                                                                    }}
                                                                >
                                                                    {pro.chApproved ? <CheckCircleOutlineIcon style={{ fontSize: 16 }} /> : <HighlightOffIcon style={{ fontSize: 16 }} />}
                                                                    {pro.chApproved ? "Approved" : "Rejected"}
                                                                </span>
                                                            )}
                                                        </StyledTableCell>

                                                    </StyledTableRow>
                                                ))
                                            ))
                                        )
                                    ))
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogContent>

                {remarkDialog && (
                    <Dialog open={remarkDialog} onClose={() => setRemarksDialog(false)} PaperProps={{ style: { borderRadius: 16, overflow: "hidden" } }}>
                        <Box className={classes.dialogHeader}>
                            <Box className={classes.dialogHeaderTitle}>
                                <HighlightOffIcon style={{ fontSize: 22 }} />
                                <Typography style={{ fontFamily: HEADING_FONT, fontSize: 17 }}>Enter Remark</Typography>
                            </Box>
                            <IconButton size="small" className={classes.dialogCloseBtn} onClick={() => setRemarksDialog(false)}>
                                <CloseIcon style={{ fontSize: 18 }} />
                            </IconButton>
                        </Box>
                        <DialogContent style={{ paddingTop: 20 }}>
                            <FormControl fullWidth>
                                <TextField
                                    id="outlined-multiline-static"
                                    label="Enter Remark"
                                    multiline
                                    rows={4}
                                    onChange={handleRejectedRemarks}
                                    name="remark"
                                    variant="outlined"
                                    size="small"
                                    className={classes.field}
                                    style={{ width: "100%" }}
                                />
                            </FormControl>
                        </DialogContent>
                        <DialogActions style={{ padding: "14px 24px 20px" }}>
                            <Button onClick={() => setRemarksDialog(false)} variant="outlined" className={classes.clearBtn}>
                                Cancel
                            </Button>
                            <Button
                                onClick={() => {
                                    setRemarksDialog(false);
                                    approveComplimentaryItems(rejectItemInfo.spaceName, rejectItemInfo.proIndex, false);
                                }}
                                variant="contained"
                                className={classes.rejectBtn}
                                style={{ background: RED, color: "#fff", border: "none" }}
                            >
                                Submit
                            </Button>
                        </DialogActions>
                    </Dialog>
                )}
            </Modal>

            {/* Note: this second Dialog has no `open` prop bound to any
                state, so it never actually renders/opens - it looks like
                leftover/superseded code from before the antd Modal above
                took over this flow. Left untouched functionally (only
                touched for consistent styling) since removing it wasn't
                asked for here. */}
            <Dialog onClose={() => setOpenItemsModal(false)} aria-labelledby="form-dialog-title" maxWidth='xl'>
                <DialogContent>
                    <TableContainer>
                        <Table aria-label="sticky table">
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell>Sr No.</StyledTableCell>
                                    <StyledTableCell>Space Name</StyledTableCell>
                                    <StyledTableCell>Complimentary Items</StyledTableCell>
                                    <StyledTableCell>Area(Sq/Ft)/Qty</StyledTableCell>
                                    <StyledTableCell>Actions / Status</StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                                {projectId && (
                                    complimentaryItemsApprovalLeads.map((lead, leadIndex) => (
                                        lead._id === projectId && (
                                            lead.complimentaryItems.map((item, itemIndex) => (
                                                item.productNames.map((pro, proIndex) => (
                                                    <StyledTableRow key={`${proIndex}`}>
                                                        <StyledTableCell>{proIndex + 1}</StyledTableCell>
                                                        <StyledTableCell>
                                                            <span className={classes.spaceTag}>{item.spaceName}</span>
                                                        </StyledTableCell>
                                                        <StyledTableCell>
                                                            <strong style={{ fontWeight: 600 }}>{pro.name}</strong>
                                                        </StyledTableCell>
                                                        <StyledTableCell style={{ fontVariantNumeric: "tabular-nums", fontWeight: 600 }}>
                                                            {pro.area}
                                                        </StyledTableCell>
                                                        <StyledTableCell>
                                                            {pro.itemApproved === undefined ? (
                                                                <Box style={{ display: 'flex', gap: 8, justifyContent: "center" }}>
                                                                    <Button onClick={() => approveComplimentaryItems(item.spaceName, proIndex, false)} variant='outlined' size="small" className={classes.rejectBtn}>
                                                                        Reject
                                                                    </Button>
                                                                    <Button onClick={() => approveComplimentaryItems(item.spaceName, proIndex, true)} variant='contained' size="small" className={classes.approveBtn}>
                                                                        Approve
                                                                    </Button>
                                                                </Box>
                                                            ) : (
                                                                pro.chApproved ? "Approved" : "Rejected"
                                                            )}
                                                        </StyledTableCell>

                                                    </StyledTableRow>
                                                ))
                                            ))
                                        )
                                    ))
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogContent>
            </Dialog>
        </div>
    )
}

export default connect(null, { setLoading, setSnackInfo })(ComplimentaryApprovalView)